import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';

export const actions = {
  REQUEST: 'Dora/auth/LOGIN_REQUEST',
  RECEIVE: 'Dora/auth/LOGIN_SUCCESS',
  FAIL: 'Dora/auth/LOGIN_FAIL',
  LOGOUT: 'Dora/auth/LOGOUT',
};

export default makeReducer({
  actions,
  handlers: {
    [actions.LOGOUT]: (state, action) => {
      return Object.assign({}, state, { data: null });
    },
  },
});

const actionCreators = makeActionCreators({
  reducerName: 'auth',
  actions,
  requestDataCall: (store, params) => API.post('auth/login', params),
});

export const login = actionCreators.requestDataIfNeeded;
export const receiveLoginToken = actionCreators.receive;
export const logout = () => (dispatch) => dispatch({ type: actions.LOGOUT });



// WEBPACK FOOTER //
// ./src/auth/duck.js